import React from "react";
import styles from "../styles.module.css";
import { formatCurrency } from "../../../../../utils/currency";

const TransactionDetailsModal = ({ data, setTransactionModal }) => {


  const teacherName = data?.teacherId?.userId?.fullName ||
    (data?.teacherId?.firstName?.data
      ? `${data.teacherId.firstName.data} ${data.teacherId.lastName?.data || ""}`
      : "Teacher");

  const gross = Number(data?.grossAmount || data?.withdrawalAmount || 0);
  const fee = Number(data?.platformFee || 0);
  const net = Number(data?.amount || (gross - fee));

  return (
    <div className={styles.modalBackdrop}>
      <div
        className={styles.modal}
        style={{ width: "750px" }}>
        <div className={styles.modal_header}>
          <h1>Payout Details</h1>
          <i
            className={styles.closeBtn + " fas fa-close"}
            onClick={() => {
              setTransactionModal(false);
            }}></i>
        </div>

        <div className={styles.modal_body} style={{ padding: "1.5rem 1.5rem" }}>
          <div className={styles.detail_row}>
            <h3>Payout ID</h3>
            <h3>{data?._id}</h3>
          </div>

          <div className={styles.detail_row}>
            <h3>Teacher Name</h3>
            <h3>{teacherName}</h3>
          </div>

          <div className={styles.detail_breakdown} style={{ margin: "1rem 0", padding: "1rem", backgroundColor: "#f8fafc", borderRadius: "12px" }}>
            <div className={styles.detail_row}>
              <h3 style={{ fontSize: "1rem" }}>Gross Wallet Balance</h3>
              <h3 style={{ fontSize: "1.1rem" }}>{formatCurrency(gross)}</h3>
            </div>
            <div className={styles.detail_row}>
              <h3 style={{ fontSize: "1rem", color: "#d9534f" }}>Platform Fee (21%)</h3>
              <h3 style={{ fontSize: "1.1rem", color: "#d9534f" }}>- {formatCurrency(fee)}</h3>
            </div>
            <hr style={{ margin: "0.5rem 0", border: "0", borderTop: "1px solid #e2e8f0" }} />
            <div className={styles.detail_row}>
              <h3 style={{ fontWeight: "700" }}>Final Payout Amount</h3>
              <h3 style={{ fontWeight: "800", color: "#5cb85c", fontSize: "1.4rem" }}>{formatCurrency(net)}</h3>
            </div>
          </div>

          <div className={styles.detail_row}>
            <h3>Payment Status</h3>
            <h3 style={{
              color: data?.status === "Completed" ? "#3c763d" : "#8a6d3b",
              backgroundColor: data?.status === "Completed" ? "#dff0d8" : "#fcf8e3",
              padding: "4px 12px",
              borderRadius: "20px",
              fontSize: "0.9rem"
            }}>{data?.status || data?.paymentStatus || "Pending"}</h3>
          </div>

          <div className={styles.detail_row}>
            <h3>Mode of Transaction</h3>
            <h3>{data?.modeOfTransaction}</h3>
          </div>

          <div className={styles.detail_row}>
            <h3>Bank Reference Id</h3>
            <h3>{data?.bankReferenceId}</h3>
          </div>

          {data?.modeOfTransaction === "UPI" && (
            <>
              <div className={styles.detail_row}>
                <h3>UPI ID</h3>
                <h3>{data?.upi?.upiId}</h3>
              </div>

              <div className={styles.detail_row}>
                <h3>Bank Verified Name</h3>
                <h3>{data?.upi?.bankVerifiedName}</h3>
              </div>
            </>
          )}

          {data?.modeOfTransaction === "Paypal" && (
            <>
              <div className={styles.detail_row}>
                <h3>PAYPAL ID</h3>
                <h3>{data?.paypal?.paypalId}</h3>
              </div>
            </>
          )}

          {data?.modeOfTransaction === "Bank Transfer" && (
            <>
              <div className={styles.detail_row}>
                <h3>Account Holder Name</h3>
                <h3>{data?.bankDetails?.accountHolderName}</h3>
              </div>

              <div className={styles.detail_row}>
                <h3>Account Number</h3>
                <h3>{data?.bankDetails?.accountNumber}</h3>
              </div>

              <div className={styles.detail_row}>
                <h3>Bank Location</h3>
                <h3>{data?.bankDetails?.bankLocation}</h3>
              </div>

              <div className={styles.detail_row}>
                <h3>Bank IFSC Code</h3>
                <h3>{data?.bankDetails?.bankIFSCode}</h3>
              </div>

              <div className={styles.detail_row}>
                <h3>Bank Swift Code</h3>
                <h3>{data?.bankDetails?.bankSwiftCode}</h3>
              </div>

              <div className={styles.detail_row}>
                <h3>Bank Account Type</h3>
                <h3>{data?.bankDetails?.bankAccountType}</h3>
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default TransactionDetailsModal;
